import React, { Component } from "react";
import Quagga from "quagga";
import { BarLoader } from "react-spinners";
import "./index.css";
import isMobile from "ismobilejs";

class BarcodeScanner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      detected: false,
      code: null,
      scannerInitialising: false
    };

    this._detect = this._detect.bind(this);
    this._quaggaInit = this._quaggaInit.bind(this);
  }

  render() {
    const { code, scannerInitialising, error } = this.state;
    return (
      <div>
        {error && <p>Error: {error}</p>}
        {scannerInitialising && (
          <div className="scanner-loader">
            <BarLoader width={200} color={"var(--primary-color)"} />
          </div>
        )}
        <div id="interactive" className="viewport" />
        {code && JSON.stringify(code)}
      </div>
    );
  }

  componentDidUpdate(prevProps, prevState) {
    const { watching } = this.props;
    if (prevProps.watching && !watching) {
      Quagga.stop();
    } else if (!prevProps.watching && watching) {
      this._quaggaInit();
    }
  }

  _quaggaInit() {
    this.setState({ scannerInitialising: true });

    let init = (error = false) => {
      this.setState({ scannerInitialising: false, error });
    };

    init = init.bind(this);

    Quagga.init(
      {
        inputStream: {
          name: "Live",
          type: "LiveStream",
          constraints: {
            width: isMobile.android.device ? 600 : { min: 640 },
            height: isMobile.android.device ? 360 : { min: 480 },
            facingMode: "environment",
            aspectRatio: { min: 1, max: 2 }
          }
        },
        decoder: {
          readers: ["code_128_reader", "code_39_reader", "ean_reader"]
        },
        locate: true,
        frequency: 10,
        locator: {
          halfSample: true,
          patchSize: "medium" // x-small, small, medium, large, x-large
        }
      },
      function(err) {
        if (err) {
          alert(err);
          init(err);
        }
        init();
        Quagga.start();
      }
    );
    Quagga.onDetected(this._detect);
    Quagga.onProcessed(this._process);
  }

  componentDidMount() {
    this._quaggaInit();
  }

  _process(result) {
    var drawingCtx = Quagga.canvas.ctx.overlay,
      drawingCanvas = Quagga.canvas.dom.overlay;
    if (result) {
      if (result.boxes) {
        drawingCtx.clearRect(
          0,
          0,
          parseInt(drawingCanvas.getAttribute("width"), 10),
          parseInt(drawingCanvas.getAttribute("height"), 10)
        );
        result.boxes
          .filter(function(box) {
            return box !== result.box;
          })
          .forEach(function(box) {
            Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
              color: "green",
              lineWidth: 2
            });
          });
      }

      if (result.box) {
        Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
          color: "#00F",
          lineWidth: 2
        });
      }

      if (result.codeResult && result.codeResult.code) {
        Quagga.ImageDebug.drawPath(
          result.line,
          { x: "x", y: "y" },
          drawingCtx,
          { color: "red", lineWidth: 3 }
        );
      }
    }
  }

  _detect(data) {
    console.log("barcode detected", data);
    this.props.onDetect(data);
  }
}

export default BarcodeScanner;



// WEBPACK FOOTER //
// ./src/components/barcode-scanner/index.js